var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"mb-5"},[_c('div',[_c('checkbox',{staticClass:"b-checkbox",model:{value:(_vm.isPermanent),callback:function ($$v) {_vm.isPermanent=$$v},expression:"isPermanent"}},[_vm._v(_vm._s(_vm.$t('CONTENT.assets.perpetual')))])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }